<script setup lang="ts">
// types
import type { StrapiHeader } from '@ts-strapi/interfaces'
// hooks
import { useHeaderDesktop } from '@composables/widgets/headers/header-desktop.hook'
// components
import HeaderLogo from '@Widgets/Headers/HeaderLogo.vue'
import HeaderActions from '@Widgets/Headers/HeaderActions.vue'
import HeaderDesktopNavItem from '@Widgets/Headers/HeaderDesktopNavItem.vue'

defineOptions({
  name: 'HeaderDesktop',
})

defineProps<{
  data: StrapiHeader
}>()

const {
  refRoot,
  refOpenIndex,
  refIsScrolled,
  open,
  close,
} = useHeaderDesktop()
</script>

<template>
  <header
    ref="refRoot"
    class="header-desktop"
    :class="{ 'header-desktop--scrolled': refIsScrolled }"
  >
    <div class="header-desktop__inner">
      <HeaderLogo
        class="header-desktop__logo"
        :logo="data.logo"
        :logo-mobile="data.logoMobile"
        :link="data.logoLink"
      />

      <nav
        class="header-desktop__nav"
        aria-label="Main"
      >
        <HeaderDesktopNavItem
          v-for="(item, index) in data.topItems"
          :key="`${item.__component}-${item.id}`"
          :item="item"
          :is-open="refOpenIndex === index"
          @click:open="open(index)"
          @click:close="close(index)"
        />
      </nav>

      <HeaderActions
        class="header-desktop__actions"
        :primary="data.primaryButton"
        :secondary="data.secondaryButton"
      />
    </div>
  </header>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderDesktop.scss" />